<div>
  <div *ngIf="props.label !== orphanTablesVisibleName;else orphan">
    <h3 class="form-field-title">
      {{props.label | showSelectedTableCategory: field.parent.parent.props.selectedItemsCategoryMap : field.name }}
    </h3>
  </div>
  <ng-template #orphan>
    <h3 class="form-field-title"
      *ngIf="orphanTablesName |  showSelectedTableCategory: field.parent.parent.props.selectedItemsCategoryMap : field.name;else no_name">
      {{orphanTablesVisibleName}}
    </h3>
  </ng-template>
  <ng-template #no_name>
    <div class="form-field-title"></div>
  </ng-template>
  <div class="column-row">
    <ng-container #fieldComponent></ng-container>
  </div>
</div>